import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingPhoto, ListingPhotoType } from './types/Listing';

interface UpdateListingPhotoOptions {
  format: string;
  rotate?: number;
  rotateIncrement?: number;
  set360?: boolean;
  type?: ListingPhotoType;
}

export default (makeCall: MakeCall) =>
  (
    listingId: number,
    photoId: number,
    {
      format,
      rotate,
      rotateIncrement,
      set360,
      type,
    }: UpdateListingPhotoOptions,
  ) =>
    makeCall<ListingPhoto[]>(
      'PUT',
      `/api/v2/listing/${listingId}/photo/${photoId}`,
      {
        query: { format },
        data: {
          rotate,
          rotateIncrement,
          set360,
          type,
        },
      },
    );
